var _style, _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhipappLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213.1 90.3",
    style: {
      enableBackground: "new 0 0 213.1 90.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{clip-path:url(#XMLID_00000124121447648365624310000014922437942029809307_);fill:url(#SVGID_1_);}\n\t\t\t.st1{clip-path:url(#XMLID_00000124121447648365624310000014922437942029809307_);fill:url(#SVGID_00000077287303174589008910000014670615272524054180_);}\n\t\t.st2{clip-path:url(#XMLID_00000124121447648365624310000014922437942029809307_);fill:#FFFFFF;}\n\t\t.st3{fill:#FFFFFF;}\n\t\t.st4{fill:#F8AD46;}\n\t")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083079234526365638400000003207842490434998975_",
    d: "M25.2,49.2c0.4,6.6-3.1,26.5,3.7,26.5     s6.6-26.8,20.6-26.8c11,0,12.5,23.1,18,23.1c6.8,0,15.3-14.2,17-24.4c4.7-28-22.2-47.8-49.7-40.9C21.3,9.9,11.1,21.1,7.8,33.7     c0.9-5.1,2.6-10.5,5.7-14.9C29.8-5.4,72.7-1.8,85.9,23.7c8.5,15.1,6.2,34.8-4.8,48.3c-3.8,4.3-7.9,9.3-14.9,9.3     c-10.5-0.1-12.9-16.8-16.9-16.7c-5.7,0.2-7,20.5-17.7,23.6C11.5,94.1,4.6,66.8,2.5,51.9C-0.6,37.7,24.1,34.8,25.2,49.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000083079234526365638400000003207842490434998975_",
    style: {
      overflow: "visible",
      fill: "#F8AD46"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000040542389168241785770000016556981119162588342_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000083079234526365638400000003207842490434998975_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 29.2164,
    cy: 81.899,
    r: 28.0896,
    gradientTransform: "matrix(0.966 0 0 0.9259 8.973812e-02 6.635386e-02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#941B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5007E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 49.9,
    style: {
      clipPath: "url(#XMLID_00000040542389168241785770000016556981119162588342_)",
      fill: "url(#SVGID_1_)"
    },
    width: 54.3,
    height: 52
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127731498406313309120000007856320692230486185_",
    cx: 79.3395,
    cy: 82.0832,
    r: 28.0896,
    gradientTransform: "matrix(0.966 0 0 0.9259 8.973812e-02 6.635386e-02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#941B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5007E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.6,
    y: 50.1,
    style: {
      clipPath: "url(#XMLID_00000040542389168241785770000016556981119162588342_)",
      fill: "url(#SVGID_00000127731498406313309120000007856320692230486185_)"
    },
    width: 54.3,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000040542389168241785770000016556981119162588342_)",
      fill: "#FFFFFF"
    },
    d: "M1.5,44.5    c0,0.5,1.9,33.9,22.7,33.6c14.2-0.2,7.5-29.5,24.4-29.5c14.9,0,11.5,23.9,20.2,23.9S88,58.7,88,42.2S74.6,4.1,46.6,4.1    S7.8,29.4,7.8,33.7s-6.4,1.1-6.2,0.6C1.7,33.8,17.4,3.3,18,2.6c0.6-0.7,25.1-13.2,26-13.5C44.9-11.2,84.2,6.5,84.6,7    c0.5,0.5,10.8,39.5,11.3,39.7S83.6,88.7,83.3,89c-0.3,0.3-21.9-0.4-21.9-0.4L48.1,68.4L33.2,97.8l-36.5-9.4l1.3-42.6L1.5,44.5z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.2,76.3c0,0.8-0.3,1.5-0.9,2c-0.6,0.6-1.3,0.8-2.1,0.8h-0.1c-0.8,0-1.5-0.3-2.1-0.8   c-0.6-0.6-0.9-1.2-0.9-2v-7c0-2.1-0.6-3.4-1.8-4c-1.3-0.6-2.6-0.5-4,0.3c-1.2,0.7-1.9,1.5-2.1,2.3c0,0.1,0,0.3-0.1,0.4c0,0,0,0,0,0   v7.9c0,0.8-0.3,1.5-0.9,2c-0.6,0.6-1.3,0.8-2.1,0.8h-0.1c-0.8,0-1.5-0.3-2.1-0.8c-0.6-0.6-0.9-1.2-0.9-2v-21c0-0.8,0.3-1.5,0.9-2.1   c0.6-0.6,1.3-0.8,2.1-0.8h0.1c0.8,0,1.5,0.3,2.1,0.8c0.6,0.6,0.9,1.2,0.9,2l0.1,7.2c2.5-1.4,4-2.1,4.6-2.2c3-0.6,5.3,0.2,7.1,2.3   c1.5,1.8,2.3,4.2,2.3,7.1L112.2,76.3z M121,58.2c-0.6,0.6-1.4,0.9-2.3,0.9c-0.9,0-1.7-0.3-2.3-0.9c-0.6-0.6-1-1.4-1-2.2   c0-0.9,0.3-1.6,1-2.2c0.6-0.6,1.4-0.9,2.3-0.9c0.9,0,1.7,0.3,2.3,0.9c0.6,0.6,1,1.4,1,2.2C122,56.9,121.6,57.6,121,58.2z    M118.7,79.3c-0.9,0-1.6-0.3-2.3-0.9c-0.6-0.6-0.9-1.3-0.9-2.1V63.9c0-0.8,0.3-1.6,0.9-2.1c0.6-0.6,1.4-0.9,2.3-0.9h0.1   c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.9,1.3,0.9,2.1v12.3c0,0.8-0.3,1.6-0.9,2.1C120.4,79,119.7,79.3,118.7,79.3L118.7,79.3z M131.1,78   v6.2c0,0.8-0.3,1.5-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9H128c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1V61.5   c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.3,0.9-0.3h3.7c0.4,0,0.6,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.8v0c1.4-0.8,2.9-1.2,4.5-1.2   c2.6,0,4.8,0.9,6.6,2.8c1.8,1.8,2.7,4.1,2.7,6.7c0,2.6-0.9,4.8-2.7,6.7c-1.8,1.8-4,2.8-6.6,2.8C134,79.2,132.5,78.8,131.1,78z    M139.1,69.9c0-1.4-0.4-2.6-1.2-3.6c-0.8-1-1.7-1.5-2.9-1.5c-0.7-0.1-1.3,0-2,0.2c-1.3,0.4-2,1.4-2,3v4.7c0.3,0.8,1,1.4,2.1,1.8   c1.3,0.5,2.6,0.4,3.9-0.2c0.6-0.3,1.1-0.8,1.5-1.6c0.4-0.7,0.5-1.6,0.5-2.5V69.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.9,69.7c0-2.6,0.9-4.8,2.7-6.7c1.8-1.8,4-2.8,6.6-2.8c2.2,0,3.7,0.9,4.5,2.8v0c0-0.6,0.2-1.1,0.7-1.5   c0.4-0.4,1-0.6,1.6-0.6h1.6c0.6,0,1.2,0.2,1.6,0.6c0.5,0.4,0.7,1,0.7,1.6V78c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.2-0.5,0.4-0.9,0.4h-2.6   c-0.4,0-0.9-0.3-1.6-1c-0.3-0.3-0.6-0.5-1-0.5c-0.4,0-0.8,0-1.1,0.2c-1.4,0.9-2.4,1.3-3.2,1.3c-2.6,0-4.8-0.9-6.6-2.8   C147.8,74.5,146.9,72.3,146.9,69.7z M152.8,69.6c0,1.4,0.4,2.6,1.2,3.6c0.8,1,1.7,1.5,2.9,1.5c0.7,0.1,1.3,0,2-0.2   c1.3-0.4,2-1.4,2-3v-4.7c-0.3-0.8-1-1.4-2.1-1.8c-1.3-0.5-2.6-0.4-3.9,0.2c-0.6,0.3-1.1,0.8-1.5,1.6c-0.4,0.7-0.5,1.6-0.5,2.5V69.6   z M175.5,77.9V84c0,0.8-0.3,1.5-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9h-0.1c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1V61.4   c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.3,0.9-0.3h3.7c0.4,0,0.6,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.8v0c1.4-0.8,2.9-1.2,4.5-1.2   c2.6,0,4.8,0.9,6.6,2.8c1.8,1.8,2.7,4.1,2.7,6.7c0,2.6-0.9,4.8-2.7,6.7c-1.8,1.8-4,2.8-6.6,2.8C178.4,79.1,176.9,78.7,175.5,77.9z    M183.6,69.8c0-1.4-0.4-2.6-1.2-3.6c-0.8-1-1.7-1.5-2.9-1.5c-0.7-0.1-1.3,0-2,0.2c-1.3,0.4-2,1.4-2,3v4.7c0.3,0.8,1,1.4,2.1,1.8   c1.3,0.5,2.6,0.4,3.9-0.2c0.6-0.3,1.1-0.8,1.5-1.6c0.4-0.7,0.5-1.6,0.5-2.5V69.8z M197.6,77.9V84c0,0.8-0.3,1.5-0.9,2.1   c-0.6,0.6-1.3,0.9-2.1,0.9h-0.1c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1V61.4c0-0.3,0.1-0.6,0.4-0.9   c0.2-0.2,0.5-0.3,0.9-0.3h3.7c0.4,0,0.6,0.1,0.9,0.3c0.2,0.2,0.4,0.5,0.4,0.8v0c1.4-0.8,2.9-1.2,4.5-1.2c2.6,0,4.8,0.9,6.6,2.8   c1.8,1.8,2.7,4.1,2.7,6.7c0,2.6-0.9,4.8-2.7,6.7c-1.8,1.8-4,2.8-6.6,2.8C200.5,79.1,199,78.7,197.6,77.9z M205.6,69.8   c0-1.4-0.4-2.6-1.2-3.6c-0.8-1-1.7-1.5-2.9-1.5c-0.7-0.1-1.3,0-2,0.2c-1.3,0.4-2,1.4-2,3v4.7c0.3,0.8,1,1.4,2.1,1.8   c1.3,0.5,2.6,0.4,3.9-0.2c0.6-0.3,1.1-0.8,1.5-1.6c0.4-0.7,0.5-1.6,0.5-2.5V69.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhipappLogoWhite);
export default __webpack_public_path__ + "static/media/whipappLogoWhite.1cda8579ec4cddc185c5edeb4c16483e.svg";
export { ForwardRef as ReactComponent };